import React from 'react';
import i18n from '../i18n/config';
import { Facebook, Instagram as InstagramIcon, Linkedin, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary-700 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {i18n.t('footer.quick_links.title')}
            </h3>
            <div className="space-y-2">
              <a href={`/#${i18n.t('anchor_links.about_us')}`} className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.quick_links.about')}
              </a>
              <a href={`/#${i18n.t('anchor_links.faq')}`} className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.quick_links.faq')}
              </a>
              <a href={`/${i18n.t('routes.loan_types')}`} className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.quick_links.services')}
              </a>
              <a href={`/${i18n.locale}/blogs`} className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.quick_links.blogs')}
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {i18n.t('contact.title')}
            </h3>
            <div className="space-y-2">
              <a 
                href={`tel:${i18n.t('contact.phone')}`}
                className="block text-gray-300 hover:text-warning-300"
              >
                {i18n.t('contact.phone')}
              </a>
              <a 
                href={`mailto:${i18n.t('contact.email')}?subject=Jautājums no mājaslapas`}
                className="block text-gray-300 hover:text-warning-300"
              >
                {i18n.t('contact.email')}
              </a>
              <a 
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(i18n.t('contact.address'))}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-gray-300 hover:text-warning-300"
              >
                {i18n.t('contact.address')}
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {i18n.t('footer.legal.title')}
            </h3>
            <div className="space-y-2">
              <a href={`/documents/${i18n.locale}/terms.pdf`} target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.legal.terms')}
              </a>
              <a href={`/documents/${i18n.locale}/privacy_policy.pdf`} target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-warning-300">
                {i18n.t('footer.legal.privacy')}
              </a>
            </div>
          </div>

          {/* <div>
            <h3 className="text-lg font-semibold mb-4">
              {i18n.t('footer.social.title')}
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com/kreditiem"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-warning-300 transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a
                href="https://instagram.com/kreditiem"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-warning-300 transition-colors duration-200"
                aria-label="Instagram"
              >
                <InstagramIcon className="w-6 h-6" />
              </a>
              <a
                href="https://linkedin.com/company/kreditiem"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-warning-300 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div> */}
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p className="text-gray-300">
            {i18n.t('footer.copyright', { year: currentYear })}
          </p>

          <p className="text-gray-300">
            {i18n.t('footer.disclaimer')}
          </p>

          <a href="https://registri.ptac.gov.lv/dokuments_KS-24_nr-9599" target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-warning-300">
            {i18n.t('footer.licence_number')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;